<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "App",

  methods: {
    resetShare() {
      window.getShareInfo = function() {
        return {
          title: "期货基差价差",
          imageUrl: "",
          desc: "热门期货品种基差价差查询",
          url:
            window.location.origin + "/market-1.0/basisandspread/index.html#/",
        };
      };
    },
    getBaseURL() {
      console.log("getBaseURL");
      return axios
        .get("/.well-known/getWebHost.json")
        .then((res) => {
          console.log("获取请求域名成功", res.data.wxsign);
          axios
            .post(
              res.data["lucy-open"] + "/wxsign-1.0" + "/do/6161.10",
              {
                url:
                  window.location.origin +
                  "/market-1.0/basisandspread/index.html#/",
              },
              {
                headers: window.paiLaApi.getPailaHeader(),
              }
            )
            .then((res) => {
              console.log("获取了初始化信息", res.data.data);
              console.log("wx", this.$wx);
              this.$wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                appId: res.data.data.appid, // 必填，公众号的唯一标识
                timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
                signature: res.data.data.sign, // 必填，签名
                jsApiList: [
                  "chooseImage",
                  "updateAppMessageShareData",
                  "updateTimelineShareData",
                ], // 必填，需要使用的JS接口列表
                openTagList: ["wx-open-launch-app"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
              });
              console.log("wx.config");
              this.$wx.ready(() => {
                console.log("wx初始化成功");
                this.changeShareContent();
              });
              this.$wx.error((res) => {
                console.log("wxerror");
                console.log("res");
              });
            })
            .catch((err) => {
              console.log("获取初始化信息失败", err);
            });
        })
        .catch((e) => {
          console.log("获取域名失败");
        });
    },
    changeShareContent() {
      console.log("分享好友内容设置");
      this.$wx.updateAppMessageShareData({
        title: "期货基差价差", // 分享标题
        desc: "热门期货品种基差价差查询", // 分享描述
        link:
          window.location.origin + "/market-1.0/basisandspread/index.html#/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:
          window.location.origin + "/news-static/assets/img/shear_logo.png",
        success: function() {
          console.log("分享好友内容设置成功");
        },
        fail: function(res) {
          console.log("分享失败", res);
        },
        cancel: function(res) {
          console.log("分享取消", res);
        },
      });
      this.$wx.updateTimelineShareData({
        title: "期货基差价差", // 分享标题、
        desc: "热门期货品种基差价差查询", // 分享描述
        link:
          window.location.origin + "/market-1.0/basisandspread/index.html#/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:
          window.location.origin + "/news-static/assets/img/shear_logo.png",
        success: function() {
          // 设置成功
          console.log("分享朋友圈内容设置成功");
        },
        fail: function(res) {
          console.log("分享失败", res);
        },
        cancel: function(res) {
          console.log("分享取消1", res);
        },
      });
    },
  },
  mounted() {
    this.resetShare();
    console.log("window.systemInfo :>> ", window.systemInfo);
    if (window.systemInfo.shell === "wechat") {
      console.log("微信 ");
      this.getBaseURL();
    } else {
      console.log("非微信环境");
    }
  },
  computed: {
    isApp() {
      return window.systemInfo.environment === "APP";
    },
    isWechat() {
      return window.systemInfo.shell === "wechat";
    },
  },
};
</script>
